import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <span className="footer-text">
          Powered by{' '}
          <a
            href="https://genxsolution.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            @ Genx Solutions
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
